import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=2f32931d&scoped=true&"
import script from "./legend.vue?vue&type=script&lang=js&"
export * from "./legend.vue?vue&type=script&lang=js&"
import style0 from "./legend.vue?vue&type=style&index=0&id=2f32931d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32931d",
  null
  
)

export default component.exports